module.exports = __webpack_public_path__ + "assets/images/2e7b23941fc23b5f2096139ae71d41b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/portfolio/sungevity/sungevity-0.jpg
// module id = 812
// module chunks = 0